import React from 'react';
import DronesMap from './drones';
import { useDispatch } from 'react-redux';
import { ArcBaseContent } from '@src/core/components';
import { ArcGoogleMap } from '@src/core/controllers';
import useGoTo from '@src/features/drone/hooks/useGoTo';
import { getGeocode } from 'use-places-autocomplete';
import { setMapLocation } from '@src/features/drone/redux/actions';
import ZonesControl from '@src/core/features/zones/components/zones-control';
import { SearchLocation } from '@src/features/drone/components/search-location';
import { CameraLayoutProvider } from '@src/features/order/components/camera-view/camera-layout-context';
import CameraMapLayout from '@src/features/order/components/camera-view/camera-map-layout';

const Maps: React.FC = () => { 
  const { goTo, position, points, removePosition, addPosition, resetGoHere } = useGoTo();
  const dispatch = useDispatch();

  const onRightClick = async (event: google.maps.MapMouseEvent) => {  
    if (!event.latLng) return;
    
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    if (!lat || !lng) return;

    addPosition({ lat, lng });

    try {
      const results = await getGeocode({ location: { lat, lng } });
      const address = results[0]?.formatted_address ?? '';

      dispatch(setMapLocation({ latitude: lat, longitude: lng, address }));
    } catch (error) {
      console.error("Geocode error:", error);
    }
  };

  return (
    <CameraLayoutProvider>
      <ArcBaseContent>
        <CameraMapLayout>
          <ArcGoogleMap onRightClick={onRightClick}>
            <ZonesControl />
            <SearchLocation addPosition={addPosition}/>
            <DronesMap
              goTo={goTo}
              position={position}
              removePosition={removePosition}
              addPosition={addPosition}
              resetGoHere={resetGoHere}
              points={points}
            />
          </ArcGoogleMap>
        </CameraMapLayout>
      </ArcBaseContent>
    </CameraLayoutProvider>
  );
};

export default Maps;
